//#region IMPORT
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import M_WOR_BASIC_01 from './WOR_BASIC_01';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
//#endregion

function M_WOR_BASIC_01F() {
  const dispatch = useDispatch();

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = async () => {
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(NavBarInfoActions.setTitleName('안전신문고'));
    } catch (e) {
      console.error('Init Error:', e);
    }
  };

  return (
    <div className="wrap">
      <M_WOR_BASIC_01 />
    </div>
  );
}

export default M_WOR_BASIC_01F;
